import HeaderBox from "../header-box";
import { Card, CardBody, Col, Container, Row, Form } from "reactstrap";
import Input from "../../../../components/Common/Input";
import {useFormik} from "formik";
import validationSchema from "./validationSchema";
import { useMemo } from "react";
import InputRadio from "../../../../components/Common/InputRadio";
import Select from "../../../../components/Common/Select";

const getDefaultBooleanValue = (value) => typeof value === 'boolean' ? value : "";

interface Props {
    data?: any;
    deviceSerialNumber: string;
    isRegistrationLoading: boolean;
    onPrev: (_values: any) => void;
    onNext: (_values: any) => void;
}

const DeviceInformationForm = ({ data = null, onPrev, onNext, deviceSerialNumber, isRegistrationLoading }: Props) => {
    const form = useFormik({
        initialValues: {
            serialNumber: deviceSerialNumber,
            deliveryDate: data?.deliveryDate || "",
            hourMeter: data?.hourMeter || "",
            isNew: data?.isNew || "",
            hasShippingOrTransportDamage: getDefaultBooleanValue(data?.hasShippingOrTransportDamage),
            allOptionsInstalled: getDefaultBooleanValue(data?.allOptionsInstalled),
        },
        validationSchema,
        validateOnMount: true,
        onSubmit: () => {
            onNext({
                device: form.values,
            });
        },
    });

    const isButtonDisabled = useMemo(() => !!Object.keys(form.errors).length, [form]);
    const newOrUsedOptions = useMemo(() => [{ label: "New", value: 'new' }, { label: "Used", value: 'used' }], []);

    return (
        <>
            <HeaderBox
                title="Register Machine"
                serialNumber={deviceSerialNumber}
                onPrev={() => onPrev({ device: form.values })}
                isDisabled={isRegistrationLoading}
            />

            <Card>
                <CardBody>
                    <Container fluid>
                        <Form
                            onSubmit={e => {
                                e.preventDefault();
                                form.handleSubmit();
                                return false;
                            }}
                        >
                            <Row className="mb-4">
                                <Col xs={12} className="font-size-18 fw-bold pb-3 text-uppercase">
                                    Machine Information
                                </Col>
                                <Col xs={12} xl={4}>
                                    <div className="mb-3">
                                        <Input
                                            label="Machine Serial Number"
                                            name="serialNumber"
                                            placeholder="Machine Serial Number"
                                            form={form}
                                            value={form.values.serialNumber}
                                            disabled
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={4}>
                                    <div className="mb-3">
                                        <Input
                                            label="Delivery Date"
                                            name="deliveryDate"
                                            placeholder="Delivery Date"
                                            form={form}
                                            type="date"
                                            value={form.values.deliveryDate}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={4}>
                                    <div className="mb-3">
                                        <Input
                                            label="Hour Meter"
                                            afterLabel=" (if applicable)"
                                            name="hourMeter"
                                            placeholder="Hour Meter"
                                            form={form}
                                            value={form.values.hourMeter}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <Select
                                            label="Was this machine purchased New or Used?"
                                            name="isNew"
                                            placeholder="Was this machine purchased New or Used?"
                                            formik={form}
                                            options={newOrUsedOptions}
                                            value = {
                                                newOrUsedOptions.filter(option =>
                                                    option.value === form.values.isNew)
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} className="font-size-18 fw-bold pb-3 text-uppercase">
                                    Delivery Information
                                </Col>
                                <Col xs={12} xl={6}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="Was there any shipping or transport damage?"
                                            name="hasShippingOrTransportDamage"
                                            form={form}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={6}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="Were all Options ordered installed?"
                                            name="allOptionsInstalled"
                                            form={form}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="text-center mt-3">
                                        <button
                                            type="submit"
                                            className="btn btn-danger save-user"
                                            disabled={isRegistrationLoading || isButtonDisabled}
                                        >
                                            SUBMIT
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </CardBody>
            </Card>
        </>
    );
};

export default DeviceInformationForm;
